import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    FormControl,
    FormHelperText,
    Grid,
    TextField,
    Autocomplete,
    Link
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { useSelector } from 'react-redux';
import { weatherConditions } from '../../utils/weatherConditions';

function ToggleableContent({ productionSheetData, data, formChange, formErrors, toggleFormOpen, setToggleFormOpen, afternoonWeatherList, eveningWeatherList }) {
    const [expandedForm, setExpandedForm] = useState(false);
    const nonFranchiseeUsers = ["Manager", "Treat Team"]; // These users cannot access sale details
    const profile = useSelector((state) => state.profile);

    const toggleContent = () => {
        setExpandedForm(!expandedForm);
        setToggleFormOpen(!toggleFormOpen);
    };

    useEffect(() => {
        // if (toggleFormOpen) {
        setExpandedForm(toggleFormOpen);
        // }
    }, [toggleFormOpen]);

    return (
        <div className="toggleable-content bg-white">
            <button className="toggle-button" onClick={toggleContent}>
                <ExpandMoreIcon className={`arrow-icon ${expandedForm ? 'expandedForm' : 'closed'}`} />
            </button>
            {expandedForm && (
                <div className={` ${expandedForm ? 'expandedForm' : ''} content mx-auto max-w-7xl px-4 sm:px-6 lg:px-8`}>
                    <Grid container spacing={4} marginTop={0} >
                        {/* {nonFranchiseeUsers.includes(profile?.role) ||
                            <>
                                <Grid item sm={3}>
                                    <FormControl
                                        fullWidth
                                    >
                                        <TextField
                                            id="net"
                                            label="Net Sales"
                                            onChange={(e) =>
                                                formChange(parseInt(e.target.value), "netSales")
                                            }
                                            value={productionSheetData?.dailySubmit?.netSales}
                                            type="number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            placeholder="Net Sales Information"
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={3}>
                                    <FormControl
                                        fullWidth
                                    >
                                        <TextField
                                            id="return"
                                            label="Return Per Container"
                                            value={productionSheetData?.dailySubmit?.returnsPerContainer}
                                            type="number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            placeholder="Return Per Container Information"
                                            onChange={(e) =>
                                                formChange(e.target.value, "returnsPerContainer")
                                            }
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        } */}
                        <Grid item sm={3}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    freeSolo
                                    id="afternoonWeatherList"
                                    disableClearable
                                    options={afternoonWeatherList?.temperatures || []}
                                    renderOption={(props, option) => <p {...props}>{option} °F</p>}
                                    size="small"
                                    variant="outlined"
                                    value={productionSheetData?.dailySubmit?.afternoonTemp}
                                    onChange={(e, value) => formChange(value, "afternoonTemp")}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            type='number'
                                            label="Afternoon Temp."
                                            InputProps={{
                                                ...params.InputProps,
                                                // type: 'search',
                                                endAdornment: '°F',
                                            }}
                                            placeholder="Afternoon Temp."
                                            onChange={(e) => !isNaN(e.target.value) && formChange(e.target.value ? e.target.value * 1 : null, "afternoonTemp")}
                                            required
                                            error={!!formErrors.afternoonTemp}
                                        />
                                    )}
                                />
                                {formErrors.afternoonTemp !== "" && (
                                    <FormHelperText error>
                                        {formErrors.afternoonTemp}
                                    </FormHelperText>)}
                            </FormControl>
                        </Grid>
                        <Grid item sm={3}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="afternoonWeather"
                                    disableClearable
                                    // Enable below line for dynamic weather conditions
                                    // options={afternoonWeatherList?.conditions?.length > 0 ? afternoonWeatherList?.conditions : weatherConditions}
                                    options={weatherConditions}
                                    size="small"
                                    variant="outlined"
                                    value={productionSheetData?.dailySubmit?.afternoonWeather}
                                    onChange={(e, value) => formChange(value, "afternoonWeather")}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Afternoon Weather"
                                            InputProps={{
                                                ...params.InputProps,
                                            }}
                                            placeholder="Afternoon Weather"
                                            required
                                            error={!!formErrors.afternoonWeather}
                                        />
                                    )}
                                />
                                {formErrors.afternoonWeather !== "" && (
                                    <FormHelperText error>
                                        {formErrors.afternoonWeather}
                                    </FormHelperText>)}
                            </FormControl>
                        </Grid>
                        <Grid item sm={3}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    freeSolo
                                    id="eveningWeatherList"
                                    disableClearable
                                    options={eveningWeatherList?.temperatures || []}
                                    renderOption={(props, option) => <p {...props}>{option} °F</p>}
                                    size="small"
                                    variant="outlined"
                                    value={productionSheetData?.dailySubmit?.eveningTemp}
                                    onChange={(e, value) => formChange(value, "eveningTemp")}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            type='number'
                                            label="Evening Temp."
                                            InputProps={{
                                                ...params.InputProps,
                                                // type: 'search',
                                                endAdornment: '°F',
                                            }}
                                            placeholder="Evening Temp."
                                            onChange={(e) => !isNaN(e.target.value) && formChange(e.target.value ? e.target.value * 1 : null, "eveningTemp")}
                                            required
                                            error={!!formErrors.eveningTemp}
                                        />
                                    )}
                                />
                                {formErrors.eveningTemp !== "" && (
                                    <FormHelperText error>
                                        {formErrors.eveningTemp}
                                    </FormHelperText>)}
                            </FormControl>
                        </Grid>
                        <Grid item sm={3}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="eveningWeather"
                                    disableClearable
                                    // Enable below line for dynamic weather conditions
                                    // options={eveningWeatherList?.conditions?.length > 0 ? eveningWeatherList?.conditions : weatherConditions}
                                    options={weatherConditions}
                                    size="small"
                                    variant="outlined"
                                    value={productionSheetData?.dailySubmit?.eveningWeather}
                                    onChange={(e, value) => formChange(value, "eveningWeather")}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Evening Weather"
                                            InputProps={{
                                                ...params.InputProps
                                            }}
                                            placeholder="Evening Weather"
                                            required
                                            error={!!formErrors.eveningWeather}
                                        />
                                    )}
                                />
                                {formErrors.eveningWeather !== "" && (
                                    <FormHelperText error>
                                        {formErrors.eveningWeather}
                                    </FormHelperText>)}
                            </FormControl>
                        </Grid>
                        {/* <Grid item sm={3}>
                            <FormControl
                                fullWidth
                            >
                                <TextField
                                    id="role"
                                    label="Role *"
                                    value={data?.profile?.role}
                                    type="text"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    placeholder="User Role"
                                    disabled
                                />
                            </FormControl>
                        </Grid> */}
                        <Grid item sm={3}>
                            <FormControl
                                fullWidth
                            >
                                <TextField
                                    id="name"
                                    label="Name *"
                                    value={productionSheetData?.dailySubmit?.userName}
                                    type="text"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    placeholder="Please enter name"
                                    onChange={(e) =>
                                        formChange(e.target.value, "userName")
                                    }
                                    error={!!formErrors.userName}
                                />
                                {formErrors.userName !== "" && (
                                    <FormHelperText error>
                                        {formErrors.userName}
                                    </FormHelperText>)}
                            </FormControl>
                        </Grid>
                        <Grid item sm={3}>
                            <FormControl
                                fullWidth
                            >
                                <TextField
                                    id="cateringEvent"
                                    label="Marketing/Catering Event"
                                    value={productionSheetData?.dailySubmit?.eventDetails}
                                    type="text"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    placeholder="Marketing or Catering event Information"
                                    onChange={(e) =>
                                        formChange(e.target.value, "eventDetails")
                                    }
                                />
                            </FormControl>
                        </Grid>
                        <Grid item sm={3}>
                            <FormControl
                                fullWidth
                            >
                                <TextField
                                    id="comments"
                                    label="Comments"
                                    value={productionSheetData?.dailySubmit?.comments}
                                    type="text"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    placeholder="Please enter your comments here"
                                    onChange={(e) =>
                                        formChange(e.target.value, "comments")
                                    }
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="flex gap-2 items-center py-2 -ml-2">
                        <Checkbox
                            size="small"
                            checked={productionSheetData?.dailySubmit?.bitIsVerified}
                            onChange={(e) => formChange(e.target.checked, "bitIsVerified")}
                        />
                        <span
                            style={{
                                fontSize: "12.5px",
                            }}
                        >
                            I have <span style={{ color: "#D41042" }}>checked the day dots on all containers of ice and there is no expired ice</span> in the store
                            <Link className='ml-1' href={process.env.REACT_APP_TERMS_OF_SERVICE_URL} target='_blank' rel="noreferrer" underline='hover' >Terms of Service</Link>
                        </span>
                    </div >
                    {formErrors.bitIsVerified !== "" && (
                        <FormHelperText error>
                            {formErrors.bitIsVerified}
                        </FormHelperText>
                    )}
                </div>
            )
            }
        </div >
    );
}

export default ToggleableContent;
